import { render, staticRenderFns } from "./dataAnalysisDetail.vue?vue&type=template&id=64252c62&scoped=true&"
import script from "./dataAnalysisDetail.vue?vue&type=script&lang=js&"
export * from "./dataAnalysisDetail.vue?vue&type=script&lang=js&"
import style0 from "./dataAnalysisDetail.vue?vue&type=style&index=0&id=64252c62&prod&lang=less&"
import style1 from "./dataAnalysisDetail.vue?vue&type=style&index=1&id=64252c62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64252c62",
  null
  
)

export default component.exports